module.exports = __webpack_public_path__ + "static/img/git-bash-options.996da61.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/cpp/images/git-bash-options.png
// module id = HODm
// module chunks = 1